import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";          // para cerrar sesión en Firebase
import { auth } from "../firebaseConfig";         // tu instancia de auth


const linkStyle = (active) => ({
  padding: "0.5rem 0.75rem",
  borderRadius: "0.5rem",
  textDecoration: "none",
  color: active ? "#111827" : "white",
  backgroundColor: active ? "white" : "transparent",
  fontWeight: active ? "600" : "400",
});

const logoutButtonStyle = {
  marginTop: "1.5rem",
  padding: "0.5rem 0.75rem",
  borderRadius: "0.5rem",
  border: "none",
  width: "100%",
  textAlign: "left",
  cursor: "pointer",
  backgroundColor: "#DC2626",
  color: "white",
  fontWeight: "600",
};


export default function Layout() {
  const location = useLocation();
  const pathname = location.pathname;

  const navigate = useNavigate();

const handleLogout = async () => {
  try {
    await signOut(auth);    // aquí se cierra sesión en Firebase
    navigate("/login");     // y te mando a la pantalla de login
  } catch (error) {
    console.error("Error al cerrar sesión:", error);
  }
};

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar */}
      <aside
        style={{
          width: "220px",
          background: "#111827",
          color: "white",
          padding: "1rem",
        }}
      >
        <h2 style={{ marginBottom: "1.5rem" }}>Musicca a la Carta Admin</h2>
        <nav style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
           <Link style={linkStyle(pathname === "/")} to="/">
            Dashboard
          </Link>
           <Link style={linkStyle(pathname === "/Songs")} to="/Songs">
            Canciones
          </Link>
          <Link style={linkStyle(pathname === "/canciones-web")} to="/canciones-web">
            Canciones Web
          </Link>
           <Link style={linkStyle(pathname === "/users")} to="/users">
            Usuarios
          </Link>
           <Link style={linkStyle(pathname === "/settings")} to="/settings">
            Configuración
          </Link>
          <Link style={linkStyle(pathname === "/PurchasesTokensList")} to="/PurchasesTokensList">
            Compras
          </Link>
          <Link style={linkStyle(pathname === "/qys")} to="/qys">
            QYS
          </Link>
          <Link style={linkStyle(pathname === "/revision")} to="/revision">
            Canciones no generadas
          </Link>
          <Link style={linkStyle(pathname === "/music-tasks")} to="/music-tasks">
            TASKS
          </Link>
          <Link style={linkStyle(pathname === "/chats")} to="/chats">
            Chats
          </Link>

          

        </nav>
        <button type="button" style={logoutButtonStyle} onClick={handleLogout}>
          Cerrar sesión
        </button>
      </aside>

      {/* Contenido */}
      <main style={{ flex: 1, padding: "1.5rem", background: "#F3F4F6" }}>
        <Outlet />
      </main>
    </div>
  );
}
